import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import lottie from 'lottie-web'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { observer } from 'mobx-react-lite'
import useLoadingStore from '../stores/useLoadingStore'


export interface LoadingProps {
    /**
     * Set the text-color on the component.
     * @default 'primary'
     */
    color?: 'primary' | 'secondary'
    /**
     * The size of the circle. If using a number, the pixel unit is assumed. If using a string, you need to provide the CSS unit
     * @default 100
     */
    size?: number | string
}

const Loading: React.FC<LoadingProps> = (props) => {
    const { size = 150, color = 'primary' } = props
    const element = useRef<HTMLDivElement>(null)
    const classes = useStyles()

    const loadingStore = useLoadingStore();
    
    let display  = 'block'

    useEffect(() => {
        let path = `${process.env.REACT_APP_IMAGE_PATH}/assets/loading/${color}.json`
        if (element.current)
            lottie.loadAnimation({
                renderer: 'svg',
                loop: true,
                autoplay: true,
                container: element.current,
                path,
            })
    }, [element, color])

    return (
        <LoadingStyle isLoading={loadingStore.isLoading}>
            <div ref={element} style={{ height: size, width: size }} className={classes.innerLoading}></div>
            {/* <div ref={element} style={{ height: size, width: size }}></div> */}
        </LoadingStyle>
    )
}


const useStyles = makeStyles((theme: Theme) => ({
    innerLoading: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
}))


const LoadingStyle = styled.div<any>`
margin: 0;
display: ${props => props.isLoading ? "block" : "none"};
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
z-index: 9999;
width: 100%;
height: 100%;
background-color: #b9b9b980; */
`

export default observer(Loading)
